import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormFields, InputTypes } from '../../models/components.models';

@Component({
  selector: 'app-form-fields',
  templateUrl: './form-fields.component.html',
  styleUrls: ['./form-fields.component.scss'],
})
export class FormFieldsComponent implements OnInit {
  @Input('form') form!: UntypedFormGroup;
  @Input('data') data!: FormFields;
  constructor() {}

  ngOnInit(): void {}
}
